<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-top grid-3">
        <div class="footer-info">
          <div class="footer-logo">
            <img src="/src/assets/images/logo.svg" alt="RC INOVAÇÕES" />
          </div>
          <p>Desenvolvemos sistemas personalizados, focados nas necessidades específicas do seu negócio.</p>
          <div class="social-media">
            <a href="#" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
            <a href="#" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
            <a href="#" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
            <a href="#" aria-label="Github"><i class="fab fa-github"></i></a>
          </div>
        </div>
        
        <div class="footer-links">
          <h4>Links Rápidos</h4>
          <ul>
            <li><router-link to="/">{{ $t('nav.home') }}</router-link></li>
            <li><router-link to="/about">{{ $t('nav.about') }}</router-link></li>
            <li><router-link to="/services">{{ $t('nav.services') }}</router-link></li>
            <li><router-link to="/projects">{{ $t('nav.projects') }}</router-link></li>
            <li><router-link to="/contact">{{ $t('nav.contact') }}</router-link></li>
          </ul>
        </div>
        
        <div class="footer-contact">
          <h4>Contato</h4>
          <div class="contact-info">
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <p>Rua Exposição, SN, Qd 9 LT 7A<br>São José, São Luis de Montes Belos - Goiás, 76100-000</p>
            </div>
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <p>(64) 99652-6581</p>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <p>contato@rcinovacoes.com.br</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="footer-bottom">
        <div class="copyright">
          <p>&copy; {{ currentYear }} RC INOVAÇÕES - {{ $t('footer.rights') }}</p>
        </div>
        <div class="footer-nav">
          <router-link to="/privacy-policy">{{ $t('footer.privacy') }}</router-link>
          <router-link to="/terms-of-use">{{ $t('footer.terms') }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
</script>

<style scoped>
.footer {
  background-color: var(--primary-color);
  color: white;
  padding: 60px 0 20px;
  font-family: 'Roboto', 'Helvetica Neue', sans-serif;
}

.footer a {
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s ease;
}

.footer a:hover {
  color: white;
}

.footer-top {
  padding-bottom: 40px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-logo img {
  height: 40px;
  margin-bottom: 15px;
}

.footer-info p {
  opacity: 0.8;
  margin-bottom: 20px;
}

.social-media {
  display: flex;
  gap: 15px;
}

.social-media a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  transition: background-color 0.3s ease;
}

.social-media a:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.footer h4 {
  color: white;
  margin-bottom: 20px;
  font-size: 1.1rem;
}

.footer-links ul {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 10px;
}

.contact-item {
  display: flex;
  margin-bottom: 15px;
}

.contact-item i {
  margin-right: 15px;
  margin-top: 5px;
}

.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
}

.copyright p {
  opacity: 0.7;
}

.footer-nav {
  display: flex;
  gap: 20px;
}

@media (max-width: 576px) {
  .footer-bottom {
    flex-direction: column;
    gap: 15px;
    text-align: center;
  }
}
</style> 